import * as React from "react"
import Footer from './Footer';
import Header from './Header';
import * as PropTypes from 'prop-types';
import { useStaticQuery, graphql } from "gatsby"
const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
      query SiteTitleQuery {
          site {
              siteMetadata {
                  title
              }
          }
      }
  `)

  return (
    <div className="flex flex-col font-sans min-h-screen text-gray-900">
      <Header siteTitle={data.site.siteMetadata.title} />
      <main className="text-gray-900">{children}</main>
      <Footer />
    </div>
  );
};
Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout;